import React, { useRef, useState } from 'react';
import { NavLink } from 'react-router-dom';
import { useOnClickOutside } from 'usehooks-ts';

import Dwergsein from '@/assets/icons/Dwergsein';
import Info from '@/assets/icons/Info';
import Megaphone from '@/assets/icons/Megaphone';
import TextBalloon from '@/assets/icons/TextBalloon';

import styles from './MoreInformation.module.css';

export const MoreInformationDialog = () => {
  const [isOpen, setIsOpen] = useState(false);
  const menuRef = useRef<HTMLDivElement>(null);
  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };
  const handleOptionClick = () => {
    setIsOpen(false);
  };

  useOnClickOutside(menuRef as React.RefObject<HTMLElement>, () => setIsOpen(false));

  return (
    <div className={styles.infoMenuStyle} ref={menuRef} data-dd-action-name='Meer informatie menu'>
      <div className={styles.infoMenuButtonStyle}>
        <Info
          fill='var(--tractie-color-content-interactive-default)'
          data-testid='informationButton'
          onClick={toggleMenu}
          aria-hidden='true'
        />
      </div>
      {isOpen && (
        <div className={styles.infoLinkItemsStyle} data-testid='informationMenu'>
          <a
            target='_blank'
            href='https://nsdigitaal.sharepoint.com/:u:/r/sites/Team-BAM/SitePages/BAM-updates.aspx'
            className={styles.infoLinkItemStyle}
            onClick={() => handleOptionClick()}
            rel='noreferrer'
            data-dd-action-name='Wat is er nieuw?'
          >
            <Megaphone className={styles.informationLinkIconStyle} aria-hidden='true' />
            <span>Wat is er nieuw?</span>
          </a>
          <a
            target='_blank'
            href='https://nsdigitaal.sharepoint.com/:b:/r/sites/BesturingOperatie/Vakpagina%20TB/BAM%20handleiding.pdf?web=1'
            className={styles.infoLinkItemStyle}
            onClick={() => handleOptionClick()}
            rel='noreferrer'
            data-dd-action-name='Handleiding BAM'
          >
            <Info className={styles.informationLinkIconStyle} aria-hidden='true' />
            <span>Handleiding BAM</span>
          </a>
          <a
            target='_blank'
            href='https://forms.office.com/Pages/ResponsePage.aspx?id=WYFFZJoNhE2WbxoTwKx6NMy5veSVTdVBkL-jIhDQ4R1UQkNYUlJWTERLMEtLWThURTNLU1VRWTdIOC4u'
            className={styles.infoLinkItemStyle}
            onClick={() => handleOptionClick()}
            rel='noreferrer'
            data-dd-action-name='Feedback geven'
          >
            <TextBalloon className={styles.informationLinkIconStyle} aria-hidden='true' />
            <span>Feedback geven</span>
          </a>
          <NavLink
            to='/status'
            className={styles.infoLinkItemStyle}
            onClick={() => handleOptionClick()}
            data-dd-action-name='Status'
          >
            <Dwergsein className={styles.informationLinkIconStyle} aria-hidden='true' />
            <span>Status</span>
          </NavLink>
        </div>
      )}
    </div>
  );
};
